<template>
  <section class="mobileHome">
    <div class="topheader">
      <p>速回收以旧换新</p>
    </div>
    <Search />
    <Foucs :banners="home.mobilebanners" />
    <div class="htips">
      <span>官方授权</span>
      <span>正品保障</span>
    </div>
    <Process />
    <Product :products="home.products" />
    <Service />
    <div class="zhimabgm"
         @click="onZhima"
         v-if="endtime<20190820105406498"></div>
    <Footer />
  </section>
</template>

<script>
import { NowTimeCode } from "@/utils/index";

import Search from "../../../components/Mobile/Home/Search";
import Foucs from "../../../components/Mobile/Home/Foucs";
import Process from "../../../components/Mobile/Home/Process";
import Product from "../../../components/Mobile/Home/Product";
import Service from "../../../components/Mobile/Home/Service";
import Footer from "../../../components/Mobile/Home/Footer";
export default {
  name: "Home",
  data () {
    return {
      active: 2,
      ordersn: {},
      userAgent: navigator.userAgent,
      endtime: NowTimeCode()

    };
  },
  components: {
    Search,
    Foucs,
    Process,
    Product,
    Service,
    Footer
  },
  mounted: function () { },
  computed: {
    home () {
      return this.$store.state.home.home;
    }
  },
  methods: {
    fetchHomeData () {
      let params = {};
      this.$store.dispatch("home/fetchHomeData", { params }).then(() => { });
    },
    onZhima () {
      let url = "https://cuxiao.m.suning.com/scms/wapdn03669.html?utm_source=pl-00005&utm_medium=hp-shs-bn-w1-m"
      window.location.href = url;
    },
  },
  created () {
    this.fetchHomeData();
  }
};
</script>
<style>
.mobileHome .topheader {
  text-align: center;
  line-height: 0.44rem;
  font-size: 0.15rem;
}
.mobileHome .htips {
  text-align: center;
  width: 1.42rem;
  background: rgba(239, 238, 238, 1);
  border-radius: 0.02rem;
  margin: 0 auto;
  border: 1px solid rgba(240, 240, 240, 1);
}
.mobileHome .htips span {
  display: inline-block;
  width: 0.685rem;
  height: 0.21rem;
  line-height: 0.21rem;
  padding: 0 0.042rem;
  font-size: 0.13rem;
  color: #333;
}
.mobileHome .htips span:nth-child(2) {
  background: #fff;
}
.zhimabgm {
  width: 0.76rem;
  height: 0.43rem;
  background: url(https://image.suhuishou.com/attached/image/20190813/20190813115001_17373.jpg)
    no-repeat;
  background-size: 100%;
  position: fixed;
  right: 0.05rem;
  bottom: 0.7rem;
}
</style>
